module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-76x76-1f66633afef85484f7975c1c979b80e0.png";